module.exports = __webpack_public_path__ + "e3ff8d5cfdf498b9073c6d46d209b793.svg";